import { combineReducers } from 'redux';
import vmware from './vmware';

export default combineReducers({
  vmware,
});
